import { render, staticRenderFns } from "./agent-permission.vue?vue&type=template&id=c4be2b06&scoped=true&"
import script from "./agent-permission.vue?vue&type=script&lang=js&"
export * from "./agent-permission.vue?vue&type=script&lang=js&"
import style0 from "./agent-permission.vue?vue&type=style&index=0&id=c4be2b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4be2b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4be2b06')) {
      api.createRecord('c4be2b06', component.options)
    } else {
      api.reload('c4be2b06', component.options)
    }
    module.hot.accept("./agent-permission.vue?vue&type=template&id=c4be2b06&scoped=true&", function () {
      api.rerender('c4be2b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-agent-management/agent-permission.vue"
export default component.exports